import Box from "@mui/material/Box";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import TableContainer from "../../../components/Tables/TableContainer";
import TableCell from "../../../pages/BillingAndPayments/components/TableCell";
import { useTranslationApp } from "../../../lib/i18next";
import {
  TEMPLATES_SAVE_VARIABLES_MISMATCH_ARIA_LABEL,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_FORMAT,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_TYPE,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_VARIABLE,
  TEMPLATES_SAVE_VARIABLES_MISMATCH_DESCRIPTION,
  TEMPLATES_SLIDES_ROW,
  TEMPLATES_TYPE_IMAGE,
  TEMPLATES_TYPE_TEXT,
} from "../../../i18n/keysTranslations";

const headerCellSx = {
  cursor: "default",
};

const wrapCellSx = {
  cursor: "default",
  verticalAlign: "top",
  whiteSpace: "normal",
  wordBreak: "break-word",
  overflow: "visible",
  textOverflow: "unset",
  height: "auto",
};

const typeLabelKey = (type) =>
  type === "image" ? TEMPLATES_TYPE_IMAGE : TEMPLATES_TYPE_TEXT;

const TemplateVariablesMismatchTable = ({ rows = [] }) => {
  const { t } = useTranslationApp();
  const rowKeys = rows.map((_, index) => String(index));
  const showSlide = rows.some((row) => row.slide);

  return (
    <Box sx={{ width: "100%", maxWidth: "100%" }}>
      <TableContainer
        keys={rowKeys}
        loading={false}
        ariaLabel={t(TEMPLATES_SAVE_VARIABLES_MISMATCH_ARIA_LABEL)}
        hasPagination={false}
        showEmptyText={false}
      >
        <TableHead>
          <TableRow>
            {showSlide ? (
              <TableCell
                isHeader
                sx={{
                  ...headerCellSx,
                  pl: "16px !important",
                  width: "22%",
                }}
              >
                {t(TEMPLATES_SLIDES_ROW)}
              </TableCell>
            ) : null}
            <TableCell
              isHeader
              sx={{
                ...headerCellSx,
                pl: showSlide ? undefined : "16px !important",
                width: "22%",
              }}
            >
              {t(TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_FORMAT)}
            </TableCell>
            <TableCell isHeader sx={{ ...headerCellSx, width: "22%" }}>
              {t(TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_TYPE)}
            </TableCell>
            <TableCell
              isHeader
              sx={{ ...headerCellSx, width: showSlide ? "34%" : "56%", minWidth: "160px" }}
            >
              {t(TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_VARIABLE)}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => {
            const isLastRow = index === rows.length - 1;
            return (
              <TableRow key={rowKeys[index]}>
                {showSlide ? (
                  <TableCell
                    indexRow={index}
                    isLastRow={isLastRow}
                    sx={{
                      ...wrapCellSx,
                      pl: "16px !important",
                    }}
                  >
                    {row.slide}
                  </TableCell>
                ) : null}
                <TableCell
                  indexRow={index}
                  isLastRow={isLastRow}
                  sx={{
                    ...wrapCellSx,
                    pl: showSlide ? undefined : "16px !important",
                  }}
                >
                  {row.format}
                </TableCell>
                <TableCell
                  indexRow={index}
                  isLastRow={isLastRow}
                  sx={wrapCellSx}
                >
                  {t(typeLabelKey(row.type))}
                </TableCell>
                <TableCell
                  indexRow={index}
                  isLastRow={isLastRow}
                  sx={wrapCellSx}
                >
                  {row.variable}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </TableContainer>
    </Box>
  );
};

export const TemplateVariablesMismatchAlertContent = ({
  rows = [],
  description,
}) => {
  const { t } = useTranslationApp();

  return (
    <Box
      sx={{
        width: "100%",
        maxHeight: "400px",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="body2" sx={{ textAlign: "center" }}>
        {description || t(TEMPLATES_SAVE_VARIABLES_MISMATCH_DESCRIPTION)}
      </Typography>
      <TemplateVariablesMismatchTable rows={rows} />
    </Box>
  );
};

export default TemplateVariablesMismatchTable;
